<template>
  <f7-page>
    <f7-navbar title="EZMeals 行動點餐" />
  </f7-page>
</template>

<script>
export default {
}
</script>
